import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/spaceGrotesk.css';
import './fonts/helveticaNeue.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import { productBrand } from './productBrand';
// Initialize Sentry as early as possible
import './services/sentry';

document
  .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
  .forEach((el) => el.parentNode?.removeChild(el));
const favicon = document.createElement('link');
favicon.rel = 'icon';
favicon.type = productBrand.faviconHref.endsWith('.png')
  ? 'image/png'
  : 'image/x-icon';
favicon.href = productBrand.faviconHref;
document.head.appendChild(favicon);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
